<template>
  <v-dialog v-model="dialog.value" persistent max-width="600">
    <template v-slot:activator="{ on: dialogOn }">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn rounded dark color="teal" v-on="{ ...dialogOn, ...tooltipOn }" @click="resetProperties">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Edytuj</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Edycja użytkownika</span>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-form ref="form">
          <v-text-field
            v-model="form.name"
            label="Imię"
            name="name"
            type="text"
            :error-messages="nameErrors"
            @input="$v.form.name.$touch()"
            @blur="$v.form.name.$touch()"
          />
          <v-text-field
            v-model="form.surname"
            label="Nazwisko"
            name="surname"
            type="text"
            :error-messages="surnameErrors"
            @input="$v.form.surname.$touch()"
            @blur="$v.form.surname.$touch()"
          />
          <v-text-field
            v-model="form.emailAddress"
            label="Adres e-mail"
            name="emailAddress"
            type="email"
            :error-messages="emailAddressErrors"
            @input="$v.form.emailAddress.$touch()"
            @blur="$v.form.emailAddress.$touch()"
          />
          <v-text-field :value="form.emailAddress" label="Nazwa użytkownika" type="text" disabled />
          <v-select
            v-model="form.roleNames"
            label="Role"
            :items="roles"
            multiple
            chips
            :error-messages="roleNamesErrors"
            item-text="display"
            item-value="name"
            @input="$v.form.roleNames.$touch()"
            @blur="$v.form.roleNames.$touch()"
          ></v-select>
          <v-checkbox v-model="form.isActive" label="Aktywny"></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text--secondary" text :disabled="dialog.loading" @click="dialog.value = false">Anuluj</v-btn>
        <v-btn color="primary" text :loading="dialog.loading" @click="create">Aktualizuj</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import RolesServiceApi from '@/api/rolesServiceApi';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('users');
const { mapState: mapAccountState } = createNamespacedHelpers('account');

export default {
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      },
      form: {
        emailAddress: null,
        name: null,
        surname: null,
        roleNames: null,
        isActive: null
      },
      roles: []
    };
  },
  computed: {
    ...mapAccountState(['token']),
    emailAddressErrors() {
      const errors = [];
      if (!this.$v.form.emailAddress.$dirty) {
        return errors;
      }
      if (!this.$v.form.emailAddress.required) {
        errors.push('Nazwa użytkownika jest wymagana');
      }
      if (!this.$v.form.emailAddress.email) {
        errors.push('Niepoprawny adres e-mail');
      }
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) {
        return errors;
      }
      if (!this.$v.form.name.required) {
        errors.push('Imię jest wymagane');
      }
      return errors;
    },
    surnameErrors() {
      const errors = [];
      if (!this.$v.form.surname.$dirty) {
        return errors;
      }
      if (!this.$v.form.surname.required) {
        errors.push('Nazwisko jest wymagane');
      }
      return errors;
    },
    roleNamesErrors() {
      const errors = [];
      if (!this.$v.form.roleNames.$dirty) {
        return errors;
      }
      if (!this.$v.form.roleNames.required) {
        errors.push('Przynajmniej jedna rola jest wymagana');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    }
  },
  validations: {
    form: {
      emailAddress: {
        required,
        email
      },
      name: {
        required
      },
      surname: {
        required
      },
      roleNames: {
        required
      }
    }
  },
  async mounted() {
    try {
      const { data } = await new RolesServiceApi(this.token).getRoles();
      this.roles = data.result.items.map(role => {
        return {
          ...role,
          name: role.name.toUpperCase(),
          display:
            role.displayName === 'Admin'
              ? 'Administrator'
              : role.displayName === 'CourseAdmin'
              ? 'Administrator szkoleń'
              : role.displayName === 'Teacher'
              ? 'Nauczyciel'
              : role.displayName
        };
      });
    } catch (e) {
      console.error(e);
      // TODO: handle
    }
  },
  methods: {
    ...mapActions(['updateUser']),
    resetProperties() {
      this.form.emailAddress = this.user.emailAddress;
      this.form.name = this.user.name;
      this.form.surname = this.user.surname;
      this.form.roleNames = this.user.roleNames;
      this.form.isActive = this.user.isActive;
      this.$v.$reset();
    },
    async create() {
      this.$v.$touch();

      if (this.formValid) {
        this.dialog.loading = true;

        await this.updateUser({
          id: this.user.id,
          userName: this.form.emailAddress,
          name: this.form.name,
          surname: this.form.surname,
          emailAddress: this.form.emailAddress,
          roleNames: this.form.roleNames,
          isActive: this.form.isActive
        });

        this.dialog.loading = false;
        this.dialog.value = false;
      }
    }
  }
};
</script>
